import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from './store';
import { Toaster } from 'react-hot-toast';
import SessionManager from './components/sessionManager/SessionManager';
import { ThemeContextProvider } from './context/ThemeContext';
import './i18n';
import { WebSocketProvider } from './context/WebSocketContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <BrowserRouter>
        <ThemeContextProvider>
          <WebSocketProvider>
            <Suspense fallback={<div>Loading translations...</div>}>
              <Toaster
                position="top-right"
                reverseOrder={false}
                toastOptions={{ duration: 4000 }}
              />
              <SessionManager />
              <App />
            </Suspense>
          </WebSocketProvider>
        </ThemeContextProvider>
      </BrowserRouter>
    </PersistGate>
  </Provider>
);

reportWebVitals();
